module.exports = __webpack_public_path__ + "img/icn_clock.403595ec.svg";